<script lang="ts">
  import { recommendation } from "../../stores/recommendation"

  $: expert = $recommendation.details?.expert
</script>

{#if expert}
  <img
    alt={`${expert.name} Photo`}
    src={expert.photo}
    class="expert-avatar {$$props.class ?? ""}"
  >
{/if}
